import store from '@state/store'

// auth related routes
const authRoutes = [
  {
    path: '/login',
    name: 'login',
    component: () => lazyLoadView(import('@views/pages/account/login')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'Dashboard' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch('auth/logOut')
        // Navigate back to previous page, or home as a fallback
        next(
          { name: 'login' }
        )
      },
    },
  },
]

// dashboard
const dashboardRoutes = [
  {
    path: '/',
    name: 'Dashboard',
    icon: 'home',
    component: () => lazyLoadView(import('@views/pages/dashboard/dashboard')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  
]

// apps
const registerRoutes = [
  {
    path: '/register',
    name: 'Cadastros',
    icon: 'cloud',
    meta: { authRequired: true },
    // create a container component
    component: {
      render(c) {
        return c('router-view')
      },
    },
    children: [
      // {
      //   path: 'patients',
      //   name: 'Pacientes',
      //   icon: 'cloud',
      //   component: () => lazyLoadView(import('@views/pages/register/patients')),
      //   meta: { authRequired: true },
      //   props: (route) => ({ user: store.state.auth.currentUser || {} }),
      // },
      {
        path: 'cliente',
        name: 'Clientes',
        icon: 'cloud',
        component: () => lazyLoadView(import('@views/pages/register/cliente')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'conveniado',
        name: 'Conveniado',
        icon: 'cloud',
        component: () => lazyLoadView(import('@views/pages/register/conveniado')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'especialidade',
        name: 'Especialidade',
        icon: 'cloud',
        component: () => lazyLoadView(import('@views/pages/register/especialidade')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'grupo',
        name: 'Grupo',
        icon: 'cloud',
        component: () => lazyLoadView(import('@views/pages/register/grupo')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      // {
      //   path: 'permissao',
      //   name: 'Permissão',
      //   icon: 'cloud',
      //   component: () => lazyLoadView(import('@views/pages/register/permissao')),
      //   meta: { authRequired: true },
      //   props: (route) => ({ user: store.state.auth.currentUser || {} }),
      // },
      {
        path: 'unidade',
        name: 'Unidade',
        icon: 'cloud',
        component: () => lazyLoadView(import('@views/pages/register/unidade')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'usuario',
        name: 'Usuário',
        icon: 'cloud',
        component: () => lazyLoadView(import('@views/pages/register/usuario')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'caixa',
        name: 'Caixa',
        icon: 'cloud',
        component: () => lazyLoadView(import('@views/pages/register/caixa')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'preco',
        name: 'Preço',
        icon: 'cloud',
        component: () => lazyLoadView(import('@views/pages/register/preco')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'importador',
        name: 'Importador',
        icon: 'cloud',
        component: () => lazyLoadView(import('@views/pages/register/importador')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },

    ],
  },
]

const comercialRoutes = [
  {
    path: '/comercial',
    name: 'Vendas',
    icon: 'trending-up',
    meta: { authRequired: true },
    component: {
      render(c) {
        return c('router-view')
      },
    },
    children: [
      {
        path: 'planos',
        name: 'Planos',
        component: () => lazyLoadView(import('@views/pages/comercial/planos')),
        meta: {authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'reagras-internacao',
        name: 'Regras Internação',
        component: () => lazyLoadView(import('@views/pages/comercial/regras-internacao')),
        meta: {authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'contato-venda',
        name: 'Contato para venda',
        component: () => lazyLoadView(import('@views/pages/comercial/contato-venda')),
        meta: {authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'vendedor',
        name: 'Vendedor',
        component: () => lazyLoadView(import('@views/pages/comercial/vendedor')),
        meta: {authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'procedimentos',
        name: 'Procedimentos',
        component: () => lazyLoadView(import('@views/pages/comercial/procedimentos')),
        meta: {authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'campanha',
        name: 'Campanha',
        component: () => lazyLoadView(import('@views/pages/comercial/campanha')),
        meta: {authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
    ]
  },
]

const agendaRoutes = [
  {
    path: '/agenda',
    name: 'Agenda',
    icon: 'calendar',
    meta: { authRequired: true },
    component: {
      render(c) {
        return c('router-view')
      },
    },
    children: [
      {
        path: 'agenda-medica',
        name: 'Agenda Médica',
        component: () => lazyLoadView(import('@views/pages/agenda/agenda-medica')),
        meta: {authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'orcamento',
        name: 'Orçamentos',
        component: () => lazyLoadView(import('@views/pages/agenda/orcamento')),
        meta: {authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'pre-agendamento',
        name: 'Pré-agendamento',
        component: () => lazyLoadView(import('@views/pages/agenda/pre-agendamento')),
        meta: {authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'internacao',
        name: 'Internação',
        component: () => lazyLoadView(import('@views/pages/agenda/internacao')),
        meta: {authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
    ]
  }
]

const atendimentoRoutes = [
  {
    path: '/atendimento',
    name: 'Atendimento',
    icon: 'user',
    meta: { authRequired: true },
    component: {
      render(c) {
        return c('router-view')
      },
    },
    children: [
      {
        path: 'cliente',
        name: 'Cliente',
        component: () => lazyLoadView(import('@views/pages/atendimento/cliente')),
        meta: {authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'autorizacao',
        name: 'Autorização',
        component: () => lazyLoadView(import('@views/pages/atendimento/autorizacao')),
        meta: {authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'pagamentos',
        name: 'Pagamentos',
        component: () => lazyLoadView(import('@views/pages/atendimento/pagamentos')),
        meta: {authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
    ]
  }
]

const autorizacaoRoutes = [
  {
    path: '/autorizacao',
    name: 'Autorizações',
    icon: 'user-check',
    meta: { authRequired: true },
    component: {
      render(c) {
        return c('router-view')
      },
    },
    children: [
      {
        path: 'cancelar-autorizacao',
        name: 'Cancelar Autorização',
        component: () => lazyLoadView(import('@views/pages/autorizacao/cancelar-autorizacao')),
        meta: {authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
    ]
  }
]

const financeiro = [
  {
    path: '/financeiro',
    name: 'Financeiro',
    icon: 'credit-card',
    meta: { authRequired: true },
    component: {
      render(c) {
        return c('router-view')
      },
    },
    children: [
      {
        path: 'gerenciamento-caixa',
        name: 'Gerenciamento de Caixa',
        component: () => lazyLoadView(import('@views/pages/financeiro/caixa')),
        meta: {authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'recebimento-mensalidade',
        name: 'Recebimento Mensalidade',
        component: () => lazyLoadView(import('@views/pages/financeiro/recebimentoMensalidade')),
        meta: {authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
    
      {
        path: 'deposito-clientes',
        name: 'Depósito De Cliente',
        component: () => lazyLoadView(import('@views/pages/financeiro/depositoClientes')),
        meta: {authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },

      {
        path: 'diary-operations',
        name: 'Operações do Dia',
        component: () => lazyLoadView(import('@views/pages/financeiro/diaryOperations')),
        meta: {authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'pagamento-conveniados',
        name: 'Pagamento De Conveniados',
        component: () => lazyLoadView(import('@views/pages/financeiro/pagamentoConveniados')),
        meta: {authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'viva-saude',
        name: 'Viva saúde',
        component: () => lazyLoadView(import('@views/pages/financeiro/vivaSaude')),
        meta: {authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      /*{
        path: 'despesas',
        name: 'Lançamento Despesas',
        component: () => lazyLoadView(import('@views/pages/financeiro/despesa')),
        meta: {authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'plano-contas',
        name: 'Plano de Contas',
        component: () => lazyLoadView(import('@views/pages/financeiro/planoContas')),
        meta: {authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'fluxo-caixa',
        name: 'Fluxo de Caixa',
        component: () => lazyLoadView(import('@views/pages/financeiro/fluxoCaixa')),
        meta: {authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'cadastros',
        name: 'Cadastros',
        icon: 'credit-card',
        meta: { authRequired: true },
        component: {
          render(c) {
            return c('router-view')
          },
        },
        children: [
          {
            path: 'centro-custo',
            name: 'Centro de Custo',
            component: () => lazyLoadView(import('@views/pages/financeiro/centroCusto')),
            meta: {authRequired: true },
            props: (route) => ({ user: store.state.auth.currentUser || {} }),
          },
          {
            path: 'banco',
            name: 'Banco',
            component: () => lazyLoadView(import('@views/pages/financeiro/banco')),
            meta: {authRequired: true },
            props: (route) => ({ user: store.state.auth.currentUser || {} }),
          },
        ]
      }*/
    ]
  }
]
const relatorios = [
  {
    path: '/relatorios',
    name: 'Relatórios',
    icon: 'file',
    meta: { authRequired: true },
    component: {
      render(c) {
        return c('router-view')
      },
    },
    children: [
      // {
      //   path: 'resumo-gerencial',
      //   name: 'Resumo Gerencial',
      //   component: () =>
      //     lazyLoadView(
      //       import('@views/pages/relatorios/relatorio-resumo-gerencial')
      //     ),
      //   meta: { authRequired: true },
      //   props: (route) => ({ user: store.state.auth.currentUser || {} }),
      // },
      // 
      // {
      //   path: 'clientes-geral',
      //   name: 'Clientes Geral',
      //   component: () =>
      //     lazyLoadView(
      //       import('@views/pages/relatorios/relatorio-clientes-geral')
      //     ),
      //   meta: { authRequired: true },
      //   props: (route) => ({ user: store.state.auth.currentUser || {} }),
      // },
      {
        path: 'clientes-situacao',
        name: 'Clientes Situação',
        component: () =>
          lazyLoadView(
            import('@views/pages/relatorios/relatorio-situacao-clientes')
          ),
        meta: { authRequired: true },
      },
      // {
      //   path: 'clientes-em-dia',
      //   name: 'Clientes em dia',
      //   component: () =>
      //     lazyLoadView(
      //       import('@views/pages/relatorios/relatorio-clientes-em-dia')
      //     ),
      //   meta: { authRequired: true },
      //   props: (route) => ({ user: store.state.auth.currentUser || {} }),
      // },
      // {
      //   path: 'cancelamento-consulta',
      //   name: 'Cancelamento Consulta',
      //   component: () =>
      //     lazyLoadView(
      //       import('@views/pages/relatorios/relatorio-cancelamento-consulta')
      //     ),
      //   meta: { authRequired: true },
      //   props: (route) => ({ user: store.state.auth.currentUser || {} }),
      // },
      // {
      //   path: 'multa',
      //   name: 'Multa',
      //   component: () =>
      //     lazyLoadView(import('@views/pages/relatorios/relatorio-multa')),
      //   meta: { authRequired: true },
      //   props: (route) => ({ user: store.state.auth.currentUser || {} }),
      // },
      // {
      //   path: 'liberacao-emegencial',
      //   name: 'Liberação Emergencial',
      //   component: () =>
      //     lazyLoadView(
      //       import('@views/pages/relatorios/relatorio-liberacao-emegencial')
      //     ),
      //   meta: { authRequired: true },
      //   props: (route) => ({ user: store.state.auth.currentUser || {} }),
      // },
      {
        path: 'novos-planos',
        name: 'Movimentação de Planos',
        component: () =>
          lazyLoadView(
            import('@views/pages/relatorios/relatorio-novos-planos')
          ),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },

      {
        path: 'adesao-e-carencia',
        name: 'Relatório de Adesão e Carencia',
        component: () =>
          lazyLoadView(
            import('@views/pages/relatorios/relatorio-adesao-e-carencia')
          ),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      // {
      //   path: 'revenda',
      //   name: 'Revenda',
      //   component: () =>
      //     lazyLoadView(import('@views/pages/relatorios/relatorio-revenda')),
      //   meta: { authRequired: true },
      //   props: (route) => ({ user: store.state.auth.currentUser || {} }),
      // },
      {
        path: 'lista-renovacao',
        name: 'Lista de Renovação',
        component: () =>
          lazyLoadView(
            import('@views/pages/relatorios/relatorio-lista-renovacao')
          ),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },

      // {
      //   path: 'renovacao-especifica',
      //   name: 'Renovação Específica',
      //   component: () =>
      //     lazyLoadView(
      //       import('@views/pages/relatorios/relatorio-renovacao-especifica')
      //     ),
      //   meta: { authRequired: true },
      //   props: (route) => ({ user: store.state.auth.currentUser || {} }),
      // },
      {
        path: 'renovacao-geral',
        name: 'Renovação Geral',
        component: () =>
          lazyLoadView(
            import('@views/pages/relatorios/relatorio-renovacao-geral')
          ),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },      
      {
        path: 'relatorio-recebimentos-futuros',
        name: 'Recebimentos Futuros',
        component: () =>
          lazyLoadView(
            import('@views/pages/relatorios/relatorio-recebimentos-futuros')
          ),
        meta: { authRequired: true },
      },
      {
        path: 'relatorio-recebimentos-atraso',
        name: 'Recebimentos em Atraso',
        component: () =>
          lazyLoadView(
            import('@views/pages/relatorios/relatorio-recebimentos-atraso')
          ),
        meta: { authRequired: true },
      },
      // {
      //   path: 'cobranca',
      //   name: 'Cobrança',
      //   component: () =>
      //     lazyLoadView(import('@views/pages/relatorios/relatorio-cobranca')),
      //   meta: { authRequired: true },
      //   props: (route) => ({ user: store.state.auth.currentUser || {} }),
      // },
      {
        path: 'cobranca-periodo',
        name: 'Cobrança Por Periodo',
        component: () =>
          lazyLoadView(import('@views/pages/relatorios/relatorio-cobranca-periodo')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'cobranca-periodo-geral',
        name: 'Relatório de recebimento geral',
        component: () =>
          lazyLoadView(import('@views/pages/relatorios/relatorio-cobranca-periodo-geral')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      // {
      //   path: 'cancelamento',
      //   name: 'Planos Cancelados',
      //   component: () =>
      //     lazyLoadView(
      //       import('@views/pages/relatorios/relatorio-planos-cancelados')
      //     ),
      //   meta: { authRequired: true },
      //   props: (route) => ({ user: store.state.auth.currentUser || {} }),
      // },
      {
        path: 'cancelamentos-gerais',
        name: 'Cancelamentos gerais',
        component: () =>
          lazyLoadView(
            import('@views/pages/relatorios/relatorio-cancelamentos-gerais')
          ),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'nota-Fical',
        name: 'Nota Fiscal',
        component: () =>
          lazyLoadView(import('@views/pages/relatorios/relatorio-nota-fiscal')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'rel-dependentes',
        name: 'Relatório dependentes',
        component: () =>
          lazyLoadView(import('@views/pages/relatorios/relatorio-dependentes')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'recebimento-por-plano',
        name: 'Relatório Recebimento por Plano',
        component: () =>
          lazyLoadView(import('@views/pages/relatorios/relatorio-recebimento-por-plano')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'subsidio',
        name: 'Subsídio',
        component: () =>
          lazyLoadView(import('@views/pages/relatorios/relatorio-subsidio')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'consumo',
        name: 'Consumo',
        component: () =>
          lazyLoadView(import('@views/pages/relatorios/relatorio-consumo')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
      {
        path: 'aniversario',
        name: 'Aniversários',
        component: () =>
          lazyLoadView(import('@views/pages/relatorios/relatorio-aniversario')),
        meta: { authRequired: true },
        props: (route) => ({ user: store.state.auth.currentUser || {} }),
      },
    ],
  },
]


const authProtectedRoutes = [
  ...dashboardRoutes, ...registerRoutes,
  ...comercialRoutes, ...agendaRoutes,
  ...financeiro, ...relatorios
]

const allRoutes = [...authRoutes, ...authProtectedRoutes]

export { allRoutes, authProtectedRoutes }

function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    delay: 400,
    timeout: 10000,
  })

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      return h(AsyncHandler, data, children)
    },
  })
}
